/** Fills the editor area exactly, so the layout never shifts when Monaco arrives (CLS ≈ 0). */
export function EditorSkeleton() {
  const widths = ['w-2/3', 'w-1/3', 'w-1/2', 'w-3/5', 'w-1/4', 'w-2/5'];
  return (
    <div
      className="flex h-full w-full flex-col gap-3 bg-code-bg px-6 py-5"
      role="status"
      aria-label="Loading the editor"
    >
      {widths.map((w, i) => (
        <div key={i} className="flex items-center gap-4">
          <span className="w-4 text-right font-mono text-meta text-code-line-number">{i + 1}</span>
          <span className={`h-3 animate-pulse rounded-sm bg-code-chrome ${w}`} />
        </div>
      ))}
    </div>
  );
}
